<template>
    <div id="app">
        <keep-alive>
            <router-view v-if="$route.meta.keepAlive && token">
                <!-- 这里是会被缓存的视图组件，比如 Home！ -->
            </router-view>
        </keep-alive>

        <router-view v-if="!$route.meta.keepAlive && token">
            <!-- 这里是不被缓存的视图组件，比如 Edit！ -->
        </router-view>
    </div>
</template>

<script>
    import Base64 from './utils/base64.js';
    // import { simulateGetUserInfo } from './account';

    export default {
        name: 'home',
        components: {},
        created() {
        },
        mounted() {
            window.returnUserInfo = (token, companyId, userInfo) => {
                console.log('returnUserInfo', token, companyId, userInfo);
                window.$store.commit('token', token || '');
                window.$store.commit('companyId', companyId || '');
                window.$store.commit('userInfo', JSON.parse(userInfo || '{}'));
            };
            window.returnUserInfo2 = (token, companyId, userInfo) => {
                userInfo = Base64.decode(userInfo.replace(/\n/g, ''));
                console.log('returnUserInfo2', token, companyId, userInfo);
                window.$store.commit('token', token || '');
                window.$store.commit('companyId', companyId || '');
                window.$store.commit('userInfo', JSON.parse(userInfo || '{}'));
            };

            window.decode = (str) => {
                console.log(Base64.decode(str.replace(/\n/g, '')));
            };
            const extMap = {
                'iso': ['iso', 'cue', 'bin', 'cif', 'fcd', 'tao', 'dao', 'dfi', 'img', 'ccd', 'mgd', 'mdf', 'mds', 'cdi', 'nrg', 'vcd'],
                'mp4': ['avi', 'flv', 'm4v', 'mkv', 'mov', 'mp4', 'mpeg', 'mpg', 'wmv', 'swf'],
                'mp3': ['m3u', 'mp2', 'mp3', 'wma'],
                'xls': ['xls', 'xlsx'],
                'doc': ['doc', 'docx'],
                'png': ['gif', 'jpeg', 'jpg', 'png', 'bmp', 'tiff'],
                'pdf': ['pdf'],
                'ppt': ['ppt', 'pptx'],
                'psd': ['psd', 'heic'],
                'ai': ['ai'],
                'txt': ['txt', 'md'],
                'zip': ['7z', 'deb', 'dmg', 'gz', 'rar', 'zip'],
                'web': ['html', 'xhtml', 'xml', 'vue', 'js', 'ts', 'json', 'php', 'asp', 'jsp', 'aspx'],
                'css': ['css', 'sass', 'scss', 'less'],
                'win': ['exe', 'dll'],
                'ttf': ['ttf', 'otf', 'ttc']
            };

            //详情页面，再次提交和编辑
            window.tempData = '';
            window.tempTitle = '';
            //详情页面，编辑
            window.tempForm = '';
            //创建页面，关联审批单
            window.tempRelate = {};

            window.saveInstance = {};

            window.storeSaveInstance = (path, data) => {
                try {
                    // console.log('onSaveInstance===>', path, data);
                    window.saveInstance[path] = data;
                } catch (error) {

                }
            };

            window.closeWindow = () => {
                if (/(BD-ANDROID)/i.test(navigator.userAgent)) {
                    window.mobile.closeWindow('');
                } else {
                    window.webkit.messageHandlers.closeWindow.postMessage('');
                }
                // } else if (/(BD-IOS)/i.test(navigator.userAgent)) {
                //     window.webkit.messageHandlers.closeWindow.postMessage('');
                // } else {
                // }
            };

            window.restoreSaveInstance = (path, data) => {
                try {
                    for (let key in window.saveInstance[path]) {
                        data[key] = window.saveInstance[path][key];
                    }
                    delete window.saveInstance[path];
                    // console.log('restoreSaveInstance===>', path, data);
                } catch (error) {

                }
            };

            window.deleteSaveInstance = (path) => {
                try {
                    // console.log('deleteSaveInstance===>', path);
                    let temp = {};
                    for (let key in window.saveInstance) {
                        temp[key] = window.saveInstance[key];
                        if (key == path) {
                            break;
                        }
                    }
                    window.saveInstance = temp;
                } catch (error) {

                }
            };

            // eslint-disable-next-line no-unused-vars
            window.addEventListener('popstate', function (e) {
                window.deleteSaveInstance(window.getCurrentPath());
            }, true);

            window.getCurrentPath = () => {
                let path = window.location.pathname;
                if (window.location.search) {
                    path += window.location.search;
                }
                return path;
            };

            window.queryRandomUid = (length) => {
                var chars = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
                var res = '';
                for (var i = 0; i < length; i++) {
                    var id = Math.ceil(Math.random() * 35);
                    res += chars[id];
                }
                return res;
            };

            window.getFileTypeImg = (fileName) => {
                console.log('getFileTypeImg', fileName);
                let arr = fileName.split('.');
                let ext = '';
                if (arr.length > 1) {
                    let suffix = arr[arr.length - 1].toLowerCase();
                    for (let i in extMap) {
                        let kind = extMap[i];
                        let has = false;
                        for (let j = 0; j < kind.length; j++) {
                            if (kind[j] == suffix) {
                                has = true;
                                break;
                            }
                        }
                        if (has) {
                            ext = i;
                            break;
                        }
                    }
                }
                console.log('ext', ext);
                if (ext) {
                    return '/static/img/file_type_' + ext + '_normal.png';
                }
                return '/static/img/file_type_unkown_normal.png';
            };

            window.filterCloudUnit = (capacity) => {
                if (capacity === 0) return '0 B';

                let k = 1024;

                let sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

                let i = Math.floor(Math.log(capacity) / Math.log(k));

                return (capacity / Math.pow(k, i)).toFixed(1) + ' ' + sizes[i];
            };

            window.getIdsByName = (data, name) => {
                let ids = [];
                let length = 0;
                if (data != null) {
                    length = data.length;
                }
                for (let i = 0; i < length; i++) {
                    ids.push(data[i][name]);
                }
                return ids;
            };

            /**
             * 选取图片
             * max:最大选取张数
             * onlyCamera
             * 返回值:[{fileId:''}]
             **/
            window.pickImage = (max, onlyCamera, extra) => {
                if (!extra) {
                    extra = {};
                }
                extra.returnType = 'pickImage';
                let data = {
                    max: max,
                    onlyCamera: onlyCamera,
                    extra: extra
                };
                if (/(BD-ANDROID)/i.test(navigator.userAgent)) {
                    window.mobile.pickImage(JSON.stringify(data));
                } else {
                    window.webkit.messageHandlers.pickImage.postMessage(JSON.stringify(data));
                }
                // } else if (/(BD-IOS)/i.test(navigator.userAgent)) {
                //     window.webkit.messageHandlers.pickImage.postMessage(JSON.stringify(data));
                // } else {
                //     window.returnValue(JSON.stringify([{ fileId: '3bd1b84e28d7401284e5840704a07f13' }]), JSON.stringify(data.extra));
                // }
            };

            /**
             * 图片预览
             * images: 图片url数组
             * index: 初始位置
             **/
            window.imagePreview = (images, index) => {
                let data = {
                    images: images,
                    index: index
                };
                if (/(BD-ANDROID)/i.test(navigator.userAgent)) {
                    window.mobile.imagePreview(JSON.stringify(data));
                } else {
                    window.webkit.messageHandlers.imagePreview.postMessage(JSON.stringify(data));
                }
                // } else if (/(BD-IOS)/i.test(navigator.userAgent)) {
                //     window.webkit.messageHandlers.imagePreview.postMessage(JSON.stringify(data));
                // } else {
                //     window.$createImagePreview({
                //         imgs: images,
                //         initialIndex: index
                //     }).show();
                // }
            };

            /**
             * 选取附件
             * max:最大选取个数
             * 返回值:[{name:'', size:'', fileId:''}]
             **/
            window.pickAttach = (max = 0, extra) => {
                if (!extra) {
                    extra = {};
                }
                extra.returnType = 'pickAttach';
                let data = {
                    max: max,
                    extra: extra
                };
                if (/(BD-ANDROID)/i.test(navigator.userAgent)) {
                    window.mobile.pickAttach(JSON.stringify(data));
                } else {
                    window.webkit.messageHandlers.pickAttach.postMessage(JSON.stringify(data));
                }
                // } else if (/(BD-IOS)/i.test(navigator.userAgent)) {
                //     window.webkit.messageHandlers.pickAttach.postMessage(JSON.stringify(data));
                // } else {
                //     window.returnValue(JSON.stringify([{
                //         fileId: '831ea2c0f4f34d009c9ea59bb5ad4c3b',
                //         name: 'picture_1534490177833.mp4',
                //         size: 296946
                //     }]), JSON.stringify(data.extra));
                // }
            };

            /**
             * 文件预览
             * file:{fileId:'', name:'', size:''}
             **/
            window.filePreview = (file) => {
                console.log('window.filePreview', file);
                let data = {
                    file: file
                };
                if (/(BD-ANDROID)/i.test(navigator.userAgent)) {
                    window.mobile.filePreview(JSON.stringify(data));
                } else {
                    window.webkit.messageHandlers.filePreview.postMessage(JSON.stringify(data));
                }
            };

            /**
             * 查看人员信息
             * @param profileId 用户id
             */
            window.showUserInfo = (profileId) => {
                console.log('window.showUserInfo', profileId);
                let data = {
                    profileId: profileId
                };
                if (/(BD-ANDROID)/i.test(navigator.userAgent)) {
                    window.mobile.showUserInfo(JSON.stringify(data));
                } else {
                    window.webkit.messageHandlers.showUserInfo.postMessage(JSON.stringify(data));
                }
            };

            /**
             * 查看客户信息
             * @param customerId 客户id
             */
            window.showCustomerInfo = (customerId) => {
                console.log('window.showCustomerInfo', customerId);
                let data = {
                    customerId: customerId
                };
                if (/(BD-ANDROID)/i.test(navigator.userAgent)) {
                    window.mobile.showCustomerInfo(JSON.stringify(data));
                } else {
                    window.webkit.messageHandlers.showCustomerInfo.postMessage(JSON.stringify(data));
                }
            };

            /**
             * 查看订单信息
             * @param orderNo 订单号
             * @param type 查看订单的方式
             */
            window.showOrderInfo = (orderNo, type) => {
                console.log('window.showOrder', orderNo);
                let data = {
                    orderNo: orderNo,
                    type: type //0 我的订单  1需我审批   2 历史审批或抄送人   3 需我出库
                };
                if (/(BD-ANDROID)/i.test(navigator.userAgent)) {
                    window.mobile.showOrderInfo(JSON.stringify(data));
                // } else if (/(BD-IOS)/i.test(navigator.userAgent)) {
                } else {
                    window.webkit.messageHandlers.showOrderInfo.postMessage(JSON.stringify(data));
                }
            };


            /**
             * 选取用户
             * multi:是否多选
             * max:最大选取个数, 0代表不限制
             * 返回值:[{realName:'', profileId:'', portraitImgUrl:''}]
             **/
            window.pickUser = (multi, selected, max = 0, withoutMe, extra) => {
                if (!extra) {
                    extra = {};
                }
                extra.returnType = 'pickUser';
                let data = {
                    selected: selected,
                    multi: multi,
                    max: max,
                    withoutMe: withoutMe,
                    extra: extra
                };
                if (/(BD-ANDROID)/i.test(navigator.userAgent)) {
                    window.mobile.pickUser(JSON.stringify(data));
                } else {
                    window.webkit.messageHandlers.pickUser.postMessage(JSON.stringify(data));
                }
                // } else if (/(BD-IOS)/i.test(navigator.userAgent)) {
                //     window.webkit.messageHandlers.pickUser.postMessage(JSON.stringify(data));
                // } else {
                //     window.returnValue(JSON.stringify([{
                //         profileId: 20160,
                //         realName: '王洲良',
                //         portraitImgUrl: 'https://vip.bdsaas.com/image/public/man_128x128.png'
                //     }]), JSON.stringify(data.extra));
                // }
            };

            /**
             * 选取客户
             * max:最大选取个数, 0代表不限制
             * 返回值:[{customerId:'', customerName:''}]
             **/
            window.pickCustomer = (selected, max = 0, extra) => {
                if (!extra) {
                    extra = {};
                }
                extra.returnType = 'pickCustomer';
                let data = {
                    selected: selected,
                    max: max,
                    extra: extra
                };
                if (/(BD-ANDROID)/i.test(navigator.userAgent)) {
                    window.mobile.pickCustomer(JSON.stringify(data));
                } else {
                    window.webkit.messageHandlers.pickCustomer.postMessage(JSON.stringify(data));
                }
                // } else if (/(BD-IOS)/i.test(navigator.userAgent)) {
                //     window.webkit.messageHandlers.pickCustomer.postMessage(JSON.stringify(data));
                // } else {
                //     window.returnValue(JSON.stringify([{
                //         customerId: 26,
                //         customerName: '李阳光'
                //     }, {
                //         customerId: 26,
                //         customerName: '李阳光'
                //     }, {
                //         customerId: 26,
                //         customerName: '李阳光'
                //     }]), JSON.stringify(data.extra));
                // }
            };

            /**
             * 选取部门
             * multi:是否多选
             * max:最大选取个数, 0代表不限制
             * 返回值:[{depName:'', depId:''}]
             **/
            window.pickDep = (multi, selected, max = 0, extra) => {
                if (!extra) {
                    extra = {};
                }
                extra.returnType = 'pickDep';
                let data = {
                    selected: selected,
                    multi: multi,
                    max: max,
                    extra: extra
                };
                if (/(BD-ANDROID)/i.test(navigator.userAgent)) {
                    window.mobile.pickDep(JSON.stringify(data));
                } else {
                    window.webkit.messageHandlers.pickDep.postMessage(JSON.stringify(data));
                }
                // } else if (/(BD-IOS)/i.test(navigator.userAgent)) {
                //     window.webkit.messageHandlers.pickDep.postMessage(JSON.stringify(data));
                // } else {
                //     window.returnValue(JSON.stringify([{
                //         depName: '总经办',
                //         depId: '44'
                //     }]), JSON.stringify(data.extra));
                // }
            };

            /**
             * 获取地理位置
             * 返回值为{address:'', lng:'', lat:''}
             **/
            window.pickLocation = (extra) => {
                if (!extra) {
                    extra = {};
                }
                extra.returnType = 'pickLocation';
                let data = {
                    extra: extra
                };
                if (/(BD-ANDROID)/i.test(navigator.userAgent)) {
                    window.mobile.pickLocation(JSON.stringify(data));
                } else {
                    window.webkit.messageHandlers.pickLocation.postMessage(JSON.stringify(data));
                }
                // } else if (/(BD-IOS)/i.test(navigator.userAgent)) {
                //     window.webkit.messageHandlers.pickLocation.postMessage(JSON.stringify(data));
                // } else {
                //     window.returnValue(JSON.stringify({
                //         address: '合肥市蜀山区亚夏汽车大厦合肥市蜀山区亚夏汽车大厦',
                //         lat: 117.2354412,
                //         lng: 117.2354412
                //     }), JSON.stringify(data.extra));
                // }
            };

            /**
             * 通过角色id选择人员
             * @param roleId 角色id
             * @param multi 是否多选
             * @param selected 已选数据
             * @param extra
             */
            window.pickRole = (roleId, multi, selected, extra) => {
                console.log('window.pickRole', roleId, multi, selected, extra);
                if (!extra) {
                    extra = {};
                }
                extra.returnType = 'pickRole';
                let data = {
                    roleId: roleId,
                    multi: multi,
                    selected: selected || [],
                    extra: extra
                };
                if (/(BD-ANDROID)/i.test(navigator.userAgent)) {
                    window.mobile.pickRole(JSON.stringify(data));
                } else {
                    window.webkit.messageHandlers.pickRole.postMessage(JSON.stringify(data));
                }
                // } else if (/(BD-IOS)/i.test(navigator.userAgent)) {
                //     window.webkit.messageHandlers.pickRole.postMessage(JSON.stringify(data));
                // } else {
                //     // window.returnValue(JSON.stringify([{
                //     //     profileId: 21050,
                //     //     realName: '堃堃',
                //     //     portraitImgUrl: 'https://vip.bdsaas.com/image/public/man_128x128.png'
                //     // }]), JSON.stringify(data.extra));
                //     window.returnValue(JSON.stringify([{
                //         profileId: 1293,
                //         realName: '尹其兵',
                //         portraitImgUrl: 'https://vip.bdsaas.com/image/public/man_128x128.png'
                //     }]), JSON.stringify(data.extra));
                // }
            };

            /**
             * 选取通知公告或公司制度
             * type 1通知公告   2公司制度
             * multi 是否多选
             * selected 已选
             */
            window.pickDocument = (type, multi, selected, extra) => {
                console.log('window.pickDocument', type, multi, selected, extra);
                if (!extra) {
                    extra = {};
                }
                extra.returnType = 'pickDocument';
                let data = {
                    type: type,
                    multi: multi,
                    selected: selected || [],
                    extra: extra
                };
                if (/(BD-ANDROID)/i.test(navigator.userAgent)) {
                    window.mobile.pickDocument(JSON.stringify(data));
                } else {
                    window.webkit.messageHandlers.pickDocument.postMessage(JSON.stringify(data));
                }
                // } else if (/(BD-IOS)/i.test(navigator.userAgent)) {
                //     window.webkit.messageHandlers.pickDocument.postMessage(JSON.stringify(data));
                // } else {
                //     window.returnValue(JSON.stringify([{
                //         type: 1,
                //         id: '71',
                //         title: '五一放假通知'
                //     }]), JSON.stringify(data.extra));
                // }
            };

            /**
             * 打开新窗口
             * @param url
             */
            window.openWindow = (url) => {
                console.log('window.openWindow', url);
                let data = {
                    url: url
                };
                if (/(BD-ANDROID)/i.test(navigator.userAgent)) {
                    window.mobile.openWindow(JSON.stringify(data));
                } else {
                    window.webkit.messageHandlers.openWindow.postMessage(JSON.stringify(data));
                }
                // } else if (/(BD-IOS)/i.test(navigator.userAgent)) {
                //     window.webkit.messageHandlers.openWindow.postMessage(JSON.stringify(data));
                // } else {
                //     window.open(url);
                // }
            };

            /**
             * 更多按钮
             * @param data {btnName: '更多', action:'', children:[{btnName:'', action:''}]}
             */
            window.moreButton = (data) => {
                try {
                    console.log('window.moreButton', data);
                    if (/(BD-ANDROID)/i.test(navigator.userAgent)) {
                        window.mobile.moreButton(JSON.stringify(data));
                    // } else if (/(BD-IOS)/i.test(navigator.userAgent)) {
                    } else {
                        window.webkit.messageHandlers.moreButton.postMessage(JSON.stringify(data));
                    }
                } catch (e) {
                    console.log('window.moreButton===>error', e);
                }
            };

            /**
             * 分享
             * @param data {
                        "companyId": 123,
                        "title": "审批：请假",
                        "content": "发起人:王洲良\n标题：请假2小时\n请假类型:事假\n开始时间:...",
                        "shareType": "APP_URL",
                        "shareUrl": "192.168.0.53/approve/detail?id=123",
                        "imgUrl": "http://vip.bdsaas.com/.../128x128.png"
                    }
             */
            window.share = (data) => {
                try {
                    console.log('window.share', data);
                    if (/(BD-ANDROID)/i.test(navigator.userAgent)) {
                        window.mobile.share(JSON.stringify(data));
                    } else {
                    // } else if (/(BD-IOS)/i.test(navigator.userAgent)) {
                        window.webkit.messageHandlers.share.postMessage(JSON.stringify(data));
                    }
                } catch (e) {
                    console.log('window.share===>error', e);
                }
            };

            /**
             * 调用日期选择器
             * srcDate yyyy-MM-dd
             * minDate yyyy-MM-dd
             * maxDate yyyy-MM-dd
             * 返回 yyyy/MM/dd
             **/
            window.pickDate = (srcDate, minDate, maxDate, extra) => {
                if (!extra) {
                    extra = {};
                }
                extra.returnType = 'pickDate';
                let data = {
                    srcDate: srcDate,
                    minDate: minDate,
                    maxDate: maxDate,
                    extra: extra
                };
                if (/(BD-ANDROID)/i.test(navigator.userAgent)) {
                    window.mobile.pickDate(JSON.stringify(data));
                // } else if (/(BD-IOS)/i.test(navigator.userAgent)) {
                //     window.webkit.messageHandlers.pickDate.postMessage(JSON.stringify(data));
                } else {
                    window.webkit.messageHandlers.pickDate.postMessage(JSON.stringify(data));
                }
            };

            /**
             * 调用时间选择器
             * srcDate yyyy-MM-dd HH:mm
             * minDate yyyy-MM-dd HH:mm
             * maxDate yyyy-MM-dd HH:mm
             * step 步进，暂时可不做
             * 返回 yyyy/MM/dd HH:mm
             **/
            window.pickTime = (srcDate, minDate, maxDate, step, extra) => {
                if (!extra) {
                    extra = {};
                }
                extra.returnType = 'pickTime';
                let data = {
                    srcDate: srcDate,
                    minDate: minDate,
                    maxDate: maxDate,
                    step: step,
                    extra: extra
                };
                if (/(BD-ANDROID)/i.test(navigator.userAgent)) {
                    window.mobile.pickTime(JSON.stringify(data));
                // } else if (/(BD-IOS)/i.test(navigator.userAgent)) {
                //     window.webkit.messageHandlers.pickTime.postMessage(JSON.stringify(data));
                } else {
                    window.webkit.messageHandlers.pickTime.postMessage(JSON.stringify(data));
                }
            };

            /**
             * 调用单项选择器
             * list [{text:'', value:''}]
             * select {text:'', value:''}
             * 返回 {text:'', value:''}
             **/
            window.pickSingle = (list, select, extra) => {
                console.log('pickSingle', list, select, extra);
                if (!extra) {
                    extra = {};
                }
                extra.returnType = 'pickSingle';
                let data = {
                    list: list,
                    select: select,
                    extra: extra
                };
                if (/(BD-ANDROID)/i.test(navigator.userAgent)) {
                    window.mobile.pickSingle(JSON.stringify(data));
                // } else if (/(BD-IOS)/i.test(navigator.userAgent)) {
                //     window.webkit.messageHandlers.pickSingle.postMessage(JSON.stringify(data));
                } else {
                    window.webkit.messageHandlers.pickSingle.postMessage(JSON.stringify(data));
                }
            };

            /**
             * 支付
             * @param orderNo 订单号
             * @param payUrl 支付参数
             * @param paymethod 支付方式  WX ZFB
             */
            window.pay = (orderNo, payUrl, paymethod) => {
                console.log('pay', orderNo, payUrl, paymethod);
                let data = {
                    orderNo: orderNo,
                    payUrl: payUrl,
                    paymethod: paymethod
                };
                if (/(BD-ANDROID)/i.test(navigator.userAgent)) {
                    window.mobile.pay(JSON.stringify(data));
                // } else if (/(BD-IOS)/i.test(navigator.userAgent)) {
                //     window.webkit.messageHandlers.pay.postMessage(JSON.stringify(data));
                } else {
                    window.webkit.messageHandlers.pay.postMessage(JSON.stringify(data));
                }
            };

            /**
             * 跳转到服务市场订单页面
             */
            window.toStoreOrder = () => {
                console.log('toStoreOrder');
                if (/(BD-ANDROID)/i.test(navigator.userAgent)) {
                    window.mobile.toStoreOrder('');
                // } else if (/(BD-IOS)/i.test(navigator.userAgent)) {
                } else {
                    window.webkit.messageHandlers.toStoreOrder.postMessage('');
                }
            };

            /**
             * 跳转到服务市场订单页面并关闭H5页面
             */
            window.toStoreOrderAndFinish = () => {
                console.log('toStoreOrder');
                if (/(BD-ANDROID)/i.test(navigator.userAgent)) {
                    window.mobile.toStoreOrderAndFinish('');
                // } else if (/(BD-IOS)/i.test(navigator.userAgent)) {
                //     window.webkit.messageHandlers.toStoreOrderAndFinish.postMessage('');
                } else {
                    window.webkit.messageHandlers.toStoreOrderAndFinish.postMessage('');
                }
            };

            /**
             * 跳转到服务市场功能管理页面
             */
            window.toStoreFunc = () => {
                console.log('toStoreFunc');
                if (/(BD-ANDROID)/i.test(navigator.userAgent)) {
                    window.mobile.toStoreFunc('');
                // } else if (/(BD-IOS)/i.test(navigator.userAgent)) {
                //     window.webkit.messageHandlers.toStoreFunc.postMessage('');
                } else {
                    window.webkit.messageHandlers.toStoreFunc.postMessage('');
                }
            };

            /**
             * 跳转到服务市场功能管理页面并关闭H5页面
             */
            window.toStoreFuncAndFinish = () => {
                console.log('toStoreFuncAndFinish');
                if (/(BD-ANDROID)/i.test(navigator.userAgent)) {
                    window.mobile.toStoreFuncAndFinish('');
                // } else if (/(BD-IOS)/i.test(navigator.userAgent)) {
                } else {
                    window.webkit.messageHandlers.toStoreFuncAndFinish.postMessage('');
                }
            };

            /**
             * 打开关联审批单
             * @param item
             */
            window.showRelate = (item) => {
                if (item.approveType == '2') {
                    window.openWindow(window.location.origin + '/flow/detail?id=' + item.id + '&time=' + new Date().getTime() + '&fromRelate=true');
                } else {
                    window.openWindow(window.location.origin + '/approve/detail?id=' + item.id + '&time=' + new Date().getTime());
                }
            };

            window.showDocument = (item) => {
                window.openWindow(window.location.origin + '/notice/detail?id=' + item.id + '&type=' + (item.type == 1 ? 4 : 3));
            };

            /**
             * 打开原生页面
             * @param scheme 模块:功能:动作
             * @param params 传递的参数
             * @param callback 回调方法
             */
            window.goNative = (scheme, params, callback) => {
                console.log('window.goNative', scheme, params, callback);
                let data = {
                    scheme: scheme,
                    params: params,
                    callback: callback
                };
                if (/(BD-ANDROID)/i.test(navigator.userAgent)) {
                    window.mobile.goNative(JSON.stringify(data));
                    // } else if (/(BD-IOS)/i.test(navigator.userAgent)) {
                } else {
                    window.webkit.messageHandlers.goNative.postMessage(JSON.stringify(data));
                }
            };

            /**
             * 打开原生页面
             * @param action action
             * @param params 传递的参数
             * @param callback 回调方法
             */
            window.goNative2 = (action, params, callback) => {
                console.log('window.goNative2', action, params, callback);
                let data = {
                    action: action,
                    params: params,
                    callback: callback
                };
                if (/(BD-ANDROID)/i.test(navigator.userAgent)) {
                    window.mobile.goNative2(JSON.stringify(data));
                }
            };
            // window.showRelate = (item) => {
            //     if (item.approveType == '2') {
            //         this.PUSH({ name: 'flow-detail', query: { id: item.id, time: new Date().getTime(), fromRelate: true } });
            //     } else {
            //         this.PUSH({ name: 'approve-detail', query: { id: item.id, time: new Date().getTime() } });
            //     }
            // };

            window.oldFollow = '';
            window.formatFollowData_V2 = (oldFollow) => {
                let newFollow = {
                    isBasic: oldFollow.isBasic,
                    approveType: oldFollow.approveType,
                    approveName: oldFollow.approveName,
                    approveDesc: oldFollow.approveDesc,
                    groupId: oldFollow.groupId,
                    iconType: oldFollow.iconType,
                    noticeType: oldFollow.noticeType,
                    opinionRemind: oldFollow.opinionRemind,
                    opinionHide: oldFollow.opinionHide,
                    titleCustom: oldFollow.titleCustom,
                    opinionRequired: oldFollow.opinionRequired,
                    repeatType: oldFollow.repeatType,
                    table: JSON.parse(oldFollow.table),
                    condition: JSON.parse(oldFollow.condition),
                    readRange: oldFollow.readRange,
                    manageRange: oldFollow.manageRange
                };
                let oldProcess = JSON.parse(oldFollow.process);
                let newProcess = {
                    edges: oldProcess.edges,
                    notifiers: oldProcess.notifiers,
                    roleCondition: oldProcess.roleCondition,
                    nodes: []
                };

                for (let i = 0; i < newFollow.table.length; i++) {
                    let cmpt = newFollow.table[i];
                    if (cmpt.componentName == 'RoleField') {
                        cmpt.componentName = 'HrField';
                        cmpt.id = cmpt.id.replace(/RoleField/, 'HrField');
                        cmpt.props.id = cmpt.props.id.replace(/RoleField/, 'HrField');
                        cmpt.title = '人力资源';
                        cmpt.props.roleField = [];
                    }
                }
                if (oldProcess.nodes) {
                    for (let i = 0; i < oldProcess.nodes.length; i++) {
                        let node = oldProcess.nodes[i];
                        let tempForm = {};
                        for (let key in node.form) {
                            let formItem = node.form[key];
                            if (key.startsWith('RoleField')) {
                                formItem.componentName = 'HrField';
                                formItem.id = formItem.id.replace(/RoleField/, 'HrField');
                                tempForm[key.replace(/RoleField/, 'HrField')] = formItem;
                            } else {
                                tempForm[key] = formItem;
                            }
                        }
                        node.form = tempForm;
                        node.notifiers = [];
                        node.rules = [];
                        newProcess.nodes.push(node);
                    }
                }
                newFollow.process = newProcess;
                newFollow.process = oldProcess;
                console.log(JSON.stringify(newFollow));
            };
            window.getUserInfo = () => {
                this.getUserInfo();
            };

            window.mobileCallback = (callback, params) => {
                window[callback](params);
            };
            this.getUserInfo();
        },
        // destroyed() {
        //     this.$store.commit('token', '');
        //     this.$store.commit('companyId', '');
        //     this.$store.commit('userInfo', {});
        // },
        methods: {
            getUserInfo() {
                if (/(BD-ANDROID)/i.test(navigator.userAgent)) {
                    console.log('getUserInfo');
                    window.mobile.getUserInfo();
                } else {
                    window.webkit.messageHandlers.getUserInfo.postMessage('');
                }
                // } else if (/(BD-IOS)/i.test(navigator.userAgent)) {
                //     window.webkit.messageHandlers.getUserInfo.postMessage('');
                // } else {
                //     simulateGetUserInfo();
                // }
            },

            returnUserInfo(token, companyId, userInfo) {
                console.log('returnUserInfo', token, companyId, userInfo);
                this.$store.commit('token', token);
                this.$store.commit('companyId', companyId);
                this.$store.commit('userInfo', JSON.parse(userInfo));
            }

        }
    };
</script>

<style lang="scss">
    @import './assets/scss/base.scss';

    #app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
    }

    #nav {
        padding: 30px;

        a {
            font-weight: bold;
            color: #2c3e50;

            &.router-link-exact-active {
                color: #42b983;
            }
        }
    }
</style>
